// @flow
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';

import { Row, Col } from 'react-flexbox-grid';
import ProjectActions from '../actions/project.actions';
import UserActions from '../actions/user.actions';
import WizardActions from '../actions/wizard.actions';
import DiffActions from '../actions/diff.actions';
import { bindActionCreators } from 'redux';
import ProgressBar from 'react-toolbox/lib/progress_bar';
import Button from '../common/ButtonComp';
import qs from 'query-string';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { routerActions } from 'react-router-redux';
import { getTranslate } from 'react-localize-redux';
import ArrowLeft from 'react-icons/lib/md/keyboard-arrow-left';
import Clear from 'react-icons/lib/md/clear';
import StripeCheckout from 'react-stripe-checkout';
import Input from 'react-toolbox/lib/input/Input';
import Dialog from 'react-toolbox/lib/dialog/Dialog';
import MdHelpOutline from 'react-icons/lib/md/help-outline';

import Tooltip from 'react-toolbox/lib/tooltip';
import Link from 'react-toolbox/lib/link';
import './CreateDatapointsComp.css';
const TooltipLink = Tooltip(Link);

const GTM_WORKSPACE =
  'https://tagmanager.google.com/#/container/accounts/{accountId}/containers/{containerId}/workspaces/{workspaceId}';
const GTM_VERSION =
  'https://tagmanager.google.com/#/versions/accounts/{accountId}/containers/{containerId}/versions/{containerVersionId}';

function replacer(str, obj) {
  return Object.keys(obj).reduce((r, k) => r.replace(`{${k}}`, obj[k]), str);
}

class CreateDatapointsComp extends Component {
  state: {
    showOverLimitDialog: boolean,
    showOverGALimitDialog: boolean
  };
  messagesEnd: any;
  constructor(props) {
    super(props);
    const {
      query: { idx = 0 },
      project
    } = this.props;
    this.state = {
      showOverLimitDialog: false,
      showOverGALimitDialog: false
    };
  }
  componentDidMount() {
    const {
      projectActions: { getDimensions },
      project
    } = this.props;
    const { accountId, webPropertyId } = project;

    getDimensions({ id: project._id, accountId, webPropertyId });
  }

  goBack() {
    const { idx = 0 } = this.props.query;
    const {
      wizard: { steps },
      routerActions
    } = this.props;
    if (!!~steps.indexOf('select-plan')) return routerActions.push(`select-plan?idx=${idx}`);
    routerActions.push(`select-web-property?idx=${idx}`);
  }

  add(dim) {
    const {
      diffActions: { addItem },
      project,
      me: { user },
      datapoints: { accountDatapoints }
    } = this.props;

    const {
      plan: {
        permissions: { maxDatapoints: maxDatapointsProject }
      }
    } = project;
    const {
      plan: {
        permissions: { maxDatapoints: maxDatapointsUser }
      }
    } = user;
    let maxDatapoints =
      maxDatapointsUser > maxDatapointsProject ? maxDatapointsUser : maxDatapointsProject;

    const { isDimOverLimit } = accountDatapoints.reduce(
      ({ maxDatapoints, isDimOverLimit }, dp) => ({
        maxDatapoints: dp.isOPHDatapoint && dp.active ? --maxDatapoints : maxDatapoints,
        isDimOverLimit: maxDatapoints <= 0
      }),
      { isDimOverLimit: false, maxDatapoints }
    );
    const { isDimOverGALimit, maxDatapoints: mx } = accountDatapoints.reduce(
      ({ maxDatapoints, isDimOverLimit }, dp) => ({
        maxDatapoints: dp.active ? --maxDatapoints : maxDatapoints,
        isDimOverGALimit: maxDatapoints <= 0
      }),
      { isDimOverGALimit: false, maxDatapoints: 20 }
    );

    if (isDimOverLimit) return this.setState({ showOverLimitDialog: true });
    if (isDimOverGALimit) return this.setState({ showOverGALimitDialog: true });
    addItem({ dim });
    setTimeout(() => {
      this.messagesEnd.scrollTop =
        (document.getElementById(dim.sid) || {}).offsetTop - this.messagesEnd.offsetTop;
    }, 0);
  }

  remove(dim) {
    const { removeItem } = this.props.diffActions;
    removeItem({ dim });
  }

  goNext() {
    const {
      query: { idx = 0 },
      project: { _id },
      wizardActions,
      routerActions
    } = this.props;

    wizardActions.setDatapointsDone({
      id: _id,
      cb: () => routerActions.push(`/wizard/seo-perfomance?idx=${idx}`)
    });
  }

  setUp({ publishTag = true, buildTag = true }, e = null) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    const {
      project: {
        _id,
        gtm: { accountId, containerId, workspaceId }
      },
      query: { idx = 0 },
      wizardActions: { wizardDone },
      projectActions: { setUpProject },
      routerActions,
      datapoints: { accountDatapoints },
      projectSettingUp
    } = this.props;
    if (projectSettingUp) return;

    setUpProject({
      id: _id,
      idx,
      accountId,
      containerId,
      workspaceId,
      accountDatapoints,
      publishTag,
      buildTag,
      cb: () => this.goNext()
    });
  }

  fetchSoruceTag = ({ cb }) => {
    const {
      project,
      datapoints: { accountDatapoints = [] }
    } = this.props;

    this.props.projectActions.getTagSourceCode({
      id: project._id,
      datapoints: accountDatapoints.filter(({ active }) => active),
      cb
    });
  };

  showSourceTag = () => {
    this.setState({
      showSourceTag: true
    });
  };

  closeSourceTag = () => {
    this.setState({
      showSourceTag: false
    });
  };

  dialogCopied = () => {
    this.input.focus();

    this.setState({
      sourceDialogCopied: true
    });
  };

  closeWorkspaceDone = () => {};
  closeVersionDone = () => {};

  render() {
    const { showSourceTag } = this.state;
    const {
      me: { user, isCharging },
      pid,
      query,
      translate,
      project,
      originDimensions,
      datapoints,
      projectSettingUp,
      routerActions,
      sourceOfTag,
      showWorkspaceDoneDialog,
      showVersionDoneDialog,
      query: { idx },
      env: { STRIPE_PUBLISHABLE_KEY },
      projectActions: { closeWorkspaceDoneDialog, closeVersionDoneDialog }
    } = this.props;
    const { stripeCustomerId } = user;

    let { accountDatapoints, available, isChanged, updating, groups: datapointGroups } = datapoints;

    const {
      plan: {
        permissions: { maxDatapoints: maxDatapointsProject }
      }
    } = project;
    const {
      plan: {
        permissions: { maxDatapoints: maxDatapointsUser }
      }
    } = user;
    let maxDatapoints =
      maxDatapointsUser > maxDatapointsProject ? maxDatapointsUser : maxDatapointsProject;

    const usedDimensions = accountDatapoints.reduce(
      (r, d) => r + (d.active && d.isOPHDatapoint ? 1 : 0),
      0
    );

    const workspaceDoneDialog = showWorkspaceDoneDialog && (
      <Dialog
        active={showWorkspaceDoneDialog}
        onEscKeyDown={this.closeWorkspaceDone}
        onOverlayClick={this.closeWorkspaceDone}
        title={`Workspace is created`}
      >
        {showWorkspaceDoneDialog.isError && <div>{`Error during publishing happened.`}</div>}
        <div className="space-big-bottom">
          <p className="space-big-bottom">
            {`Please publish the workspace:`}{' '}
            <a target="_blank" href={replacer(GTM_WORKSPACE, showWorkspaceDoneDialog)}>
              {'GO TO WORKSPACE'}
            </a>
          </p>
        </div>
        <div className="kwh-button-group">
          <Button big primary to={`/projects`} onClick={closeWorkspaceDoneDialog}>
            {translate('app.ok')}
          </Button>
        </div>
      </Dialog>
    );
    const versionDoneDialog = showVersionDoneDialog && (
      <Dialog
        active={showVersionDoneDialog}
        onEscKeyDown={this.closeVersionDone}
        onOverlayClick={this.closeVersionDone}
        title={`Version is created`}
      >
        <div>{`Error during publishing happened.`}</div>
        <div className="space-big-bottom">
          <p>
            {`Please publish the version manually:`}{' '}
            <a target="_blank" href={replacer(GTM_VERSION, showVersionDoneDialog)}>
              {'GO TO VERSION'}
            </a>
          </p>
        </div>
        <div className="kwh-button-group">
          <Button big primary to={`/projects`} onClick={closeVersionDoneDialog}>
            {translate('app.ok')}
          </Button>
        </div>
      </Dialog>
    );
    const sourceTagDialog = showSourceTag &&
      sourceOfTag && (
        <Dialog
          active={showSourceTag}
          onEscKeyDown={this.closeSourceTag}
          onOverlayClick={this.closeSourceTag}
          title={translate('wizard.create_datapoints.copyTag.title')}
        >
          <Row>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Row>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <CopyToClipboard
                    onCopy={() => {
                      this.dialogCopied();
                    }}
                    text={sourceOfTag.tag}
                  >
                    <Input
                      innerRef={(e) => (this.input = e)}
                      onFocus={(e) => e.target.select()}
                      className="source-tag-input"
                      rows={30}
                      multiline={true}
                      value={sourceOfTag.tag}
                    />
                  </CopyToClipboard>
                </Col>
              </Row>

              <Row>
                <Col xsOffset={2}>
                  <Button
                    big
                    secondary={true}
                    className="clode-btn"
                    onClick={() => this.closeSourceTag()}
                  >
                    {translate('wizard.create_datapoints.close')}
                  </Button>
                </Col>

                <Col xs={3} sm={3} md={3} lg={3}>
                  <Button big primary={true} onClick={() => this.dialogCopied()}>
                    {translate('wizard.create_datapoints.copy')}
                  </Button>
                </Col>

                <Col xs={3} sm={3} md={3} lg={3}>
                  <Button
                    big
                    primary={true}
                    onClick={() => this.setUp({ publishTag: false, buildTag: false })}
                  >
                    {translate('wizard.create_datapoints.next')}
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Dialog>
      );

    const dimensionsUpdating = updating && <ProgressBar type="linear" mode="indeterminate" />;

    const next = (
      <Button big primary onClick={this.goNext.bind(this)}>
        {translate('app.next')}
      </Button>
    );
    const setup = (
      <Button
        big
        primary
        loading={projectSettingUp}
        disabled={!datapoints.isChanged}
        onClick={this.setUp.bind(this)}
      >
        {`PUBLISH`}
      </Button>
    );
    const setupWithoutPublishQM = (
      <TooltipLink
        key="1"
        tooltip={`Use this option if you don’t want to give Onpage Hero publishing rights but deploy the code yourself.`}
        className="kwh-help-icon"
      >
        <MdHelpOutline />
      </TooltipLink>
    );
    const setupWithoutPublish = [
      <a
        key="0"
        className="get_source_link"
        href="#"
        onClick={this.setUp.bind(this, { publishTag: false, buildTag: true })}
      >
        {`or create the tag in GTM and publish it yourself`}
      </a>,
      setupWithoutPublishQM
    ];

    const back = (
      <Button big secondary onClick={this.goBack.bind(this)}>
        {translate('app.back')}
      </Button>
    );
    const pleaseWait = projectSettingUp && (
      <div className="please_wait">Please wait, setup can take up to several minutes.</div>
    );
    const getSourceTagBtnQM = (
      <TooltipLink
        key="1"
        tooltip={`Use this option if you just want to create the source code and paste it in GTM yourself.`}
        className="kwh-help-icon"
      >
        <MdHelpOutline />
      </TooltipLink>
    );
    const getSourceTagBtn = [
      <a
        href="#"
        key="0"
        className="get_source_link"
        onClick={(e) => {
          this.fetchSoruceTag({
            cb: () => {
              this.showSourceTag();
            }
          });
          e.preventDefault();
          e.stopPropagation();
          return false;
        }}
      >
        {'or just create the source code and paste and publish it yourself'}
      </a>,
      getSourceTagBtnQM
    ];

    const overLimitDialog = (
      <Dialog active={this.state.showOverLimitDialog}>
        <h2>
          <center>{`You reached a limit of dimensions for your plan`}</center>
        </h2>

        <div className="kwh-button-group center">
          <Button big secondary onClick={() => this.setState({ showOverLimitDialog: false })}>
            {'CANCEL'}
          </Button>
          <Button
            big
            primary
            onClick={() => {
              routerActions.push(`select-plan?idx=${idx}`);
            }}
          >
            {'CHANGE PLAN'}
          </Button>
        </div>
      </Dialog>
    );

    const overGALimitDialog = (
      <Dialog active={this.state.showOverGALimitDialog}>
        <h2>
          <center>{`You reached a limit of dimensions in GA account`}</center>
        </h2>
        <div className="space-big-bottom">{`Unfortunately there is a limit of 20 dimensions per webproperty in Google Analytics. You need to replace existing dimensions if you want to add Onpage Hero datapoints.`}</div>
        <div className="kwh-button-group center">
          <Button big primary onClick={() => this.setState({ showOverGALimitDialog: false })}>
            {'OK'}
          </Button>
        </div>
      </Dialog>
    );

    return (
      <div className="wizard-upload_create">
        <h1>{translate('wizard.create_datapoints.create_mirror')}</h1>
        <p className="space-big-bottom">
          {translate('wizard.create_datapoints.create_mirror_details', {
            appAccEmail: project.accessEmail
          })}
        </p>
        <Row start="xs" className="space-big-bottom">
          <Col xs={6}>
            <h5>
              DIMENSIONS for ({project.webPropertyId}), {usedDimensions} used of {maxDatapoints}{' '}
              available
            </h5>
            <div
              className="select-list"
              ref={(el) => {
                this.messagesEnd = el;
              }}
            >
              {updating && dimensionsUpdating}
              {accountDatapoints.map(renderOriginDimensions.bind(this))}
              {!(updating && dimensionsUpdating) &&
                accountDatapoints.length === 0 &&
                `No Datapoints`}
            </div>
          </Col>
          <Col xs={6}>
            <h5>DATAPOINTS</h5>
            <div className="select-list list-left">
              {datapointGroups
                .filter(({ datapoints = [] }) =>
                  datapoints.some((name) => available.find(({ sid }) => sid === name))
                )
                .map(({ name: groupName, datapoints, description }) => (
                  <div key={groupName}>
                    <div className="datapoint-group-title">
                      <h3>{groupName}</h3>

                      {description && (
                        <TooltipLink
                          tooltipPosition="right"
                          tooltip={description}
                          className="kwh-help-icon"
                        >
                          <MdHelpOutline />
                        </TooltipLink>
                      )}
                    </div>
                    <div className="grouped-datapoints">
                      {datapoints.map((name) => {
                        if (!available.find(({ sid }) => sid === name)) {
                          return null;
                        }

                        return renderDatapointsAvailabale.call(
                          this,
                          available.find(({ sid }) => sid === name)
                        );
                      })}
                    </div>
                    <div />
                  </div>
                ))}
            </div>
          </Col>
        </Row>
        {overLimitDialog}
        {overGALimitDialog}
        <div className="kwh-button-group space-medium-bottom">
          {back}
          {!!project.setupDate && !datapoints.isChanged ? next : setup}
          {pleaseWait}
        </div>
        <div className="space-tiny-bottom">{datapoints.isChanged && setupWithoutPublish}</div>
        <div>{(!!project.setupDate || !!datapoints.isChanged) && getSourceTagBtn}</div>
        {sourceTagDialog}
        {workspaceDoneDialog}
        {versionDoneDialog}
      </div>
    );
  }
}

function renderDatapointsAvailabale(datapoint) {
  const itemClassName = ['select-list_item'].join(' ');

  return (
    <div className={itemClassName} onClick={this.add.bind(this, datapoint)} key={datapoint.sid}>
      <ArrowLeft className="select-list_arrow" />
      <span>{datapoint.name}</span>
      <small>{datapoint.description}</small>
    </div>
  );
}
function renderOriginDimensions(dimension, i) {
  const itemClassName = [
    'select-list_item',
    dimension.isTouched ? 'add_datapoint' : '',
    dimension.isAccountDatapoint && dimension.isOPHDatapoint ? 'patch_datapoint' : '',
    !dimension.active ? 'select-list_faded' : '',
    dimension.overPlanLimit ? 'over_limit' : ''
  ].join(' ');
  const actions = [
    dimension.isOPHDatapoint &&
      dimension.active && (
        <Clear
          key="clear"
          className="select-list_clear-selection"
          onClick={this.remove.bind(this, dimension)}
        />
      )
  ];
  return (
    <div className={itemClassName} key={i} id={`${dimension.sid}`}>
      <span>{dimension.name}</span>
      <small>{dimension.sid ? `ga:dimension${i + 1}` : dimension.id}</small>
      {actions}
    </div>
  );
}

function mapStateToProps(state) {
  const {
    routing: {
      location: { search }
    },
    project: {
      accounts,
      webProperties,
      accountsUpdating,
      webPropertiesUpdating,
      webPropertiesCreating,
      dimensions,
      projectSettingUp,
      sourceOfTag,
      showWorkspaceDoneDialog,
      showVersionDoneDialog
    },
    datapoints
  } = state;
  const query = search ? qs.parse(search) : { idx: 0 };
  return {
    translate: getTranslate(state.locale),
    wizard: state.wizard,
    query,
    me: state.me,
    project: state.me.user && state.me.user.projects[query.idx],
    env: state.env,
    originDimensions: dimensions,
    datapoints,
    projectSettingUp,
    sourceOfTag,
    showWorkspaceDoneDialog,
    showVersionDoneDialog
  };
}

function mapDispatchToProps(dispatch) {
  return {
    projectActions: bindActionCreators(ProjectActions, dispatch),
    userActions: bindActionCreators(UserActions, dispatch),
    routerActions: bindActionCreators(routerActions, dispatch),
    diffActions: bindActionCreators(DiffActions, dispatch),
    wizardActions: bindActionCreators(WizardActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateDatapointsComp);



// WEBPACK FOOTER //
// ./src/wizard/CreateDatapointsComp.js